import { render } from "./AwardRiskWhitelist.vue?vue&type=template&id=45251c04"
import script from "./AwardRiskWhitelist.vue?vue&type=script&lang=js"
export * from "./AwardRiskWhitelist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__